import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcChat32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m27 2c1.594 0 3 1.436 3 2.997v15.026c0 1.623-1.332 2.972-3 2.984h-17.156c-.25 0-.469.062-.625.218l-5.281 5.245c-.313.313-.72.531-1.094.531a.865.865 0 0 1 -.844-.875v-23.13c0-1.59 1.332-2.996 3.003-2.996zm.125 1.998h-22.125c-.5 0-1 .374-1 .874v20.726l3.688-3.746c.467-.468 1.062-.852 1.936-.852h17.376c.5 0 1-.375 1-.874v-15.13c0-.499-.375-.998-.875-.998zm-20.125 11c0-.498.406-.998 1-.998h16c.563 0 1 .437 1 .999 0 .5-.375.999-.875.999h-16.125c-.563 0-1-.437-1-1zm0-5c0-.498.438-.998 1-.998h16c.563 0 1 .437 1 .999 0 .5-.375.999-.875.999h-16.125c-.563 0-1-.437-1-1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcChat32;
